var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-outer-wrapper" },
    [
      _c(
        "el-row",
        { staticClass: "main-content" },
        [
          _c(
            "el-col",
            { staticClass: "left-content", attrs: { xs: 24, sm: 12 } },
            [
              _c(
                "div",
                { staticClass: "content-wrapper" },
                [
                  _c("h2", { staticClass: "title" }, [
                    _vm._v("U-Connect: Collaborate, Grow,")
                  ]),
                  _vm._v(" "),
                  _c("h3", { staticClass: "subtitle" }, [
                    _vm._v("and Expand Your Business Today ")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "description" }, [
                    _vm._v(
                      "\n            Join U-Connect; a B2B platform linking professionals to\n            access exclusive off-the-plan properties, collaborate for\n            unique revenue stream opportunities and grow your\n            national real estate stock list\n\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("el-row", [
                    _c("span", [
                      _vm._v(
                        "Get started for only $89/month.  Enter your email to create your membership."
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    {
                      staticStyle: { "margin-top": "20px" },
                      attrs: { gutter: 20 }
                    },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "requestAgentForm",
                          staticStyle: {
                            "font-family": "DINosaur-a, sans-serif"
                          },
                          attrs: {
                            model: _vm.requestUConnectForm,
                            rules: _vm.rules,
                            "label-position": "top",
                            "label-width": "100px"
                          },
                          nativeOn: {
                            submit: function($event) {
                              $event.preventDefault()
                            }
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { prop: "email" } },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          maxlength: "100",
                                          placeholder: "Your email",
                                          disabled: _vm.user != null
                                        },
                                        model: {
                                          value: _vm.requestUConnectForm.email,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.requestUConnectForm,
                                              "email",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "requestUConnectForm.email"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { staticStyle: { "text-align": "center" } },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "join-btn",
                                          on: {
                                            click: function($event) {
                                              return _vm.checkUserAndCreate(
                                                "requestAgentForm"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                        Join U-Connect\n                        "
                                          ),
                                          _vm.loading
                                            ? _c("i", {
                                                staticClass: "el-icon-loading"
                                              })
                                            : _vm._e()
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("el-divider", [
                            _vm._v(" Already have an Account? ")
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticClass: "sign-in-btn",
                              attrs: { type: "primary", size: "large" },
                              on: { click: _vm.goToUConnect }
                            },
                            [
                              _vm._v(
                                "\n                SIGN IN\n              "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { staticClass: "right-content", attrs: { xs: 24, sm: 12 } },
            [
              _c("div", { staticClass: "image-wrapper" }, [
                _c("img", {
                  staticClass: "background-image",
                  attrs: {
                    src: require("../../../assets/u-connect-reg-background.png"),
                    alt: ""
                  }
                })
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticStyle: {
            margin: "10% 0",
            "font-family": "DINosaur-a",
            color: "#003333"
          },
          attrs: {
            "before-close": _vm.handleCloseRegisterDialog,
            visible: _vm.alertDialogVisible,
            center: "",
            title: _vm.dialogBoxTitle,
            width: "100%"
          },
          on: {
            "update:visible": function($event) {
              _vm.alertDialogVisible = $event
            }
          }
        },
        [
          _vm.userTypeErrorCode === 70000
            ? [
                _c("span", { staticClass: "forgotPasswordSpan" }, [
                  _vm._v(_vm._s(this.dialogBoxMessage) + ". Please login.")
                ])
              ]
            : _vm.userTypeErrorCode === 60001
            ? [
                _c(
                  "span",
                  {
                    staticClass: "forgotPasswordSpan",
                    domProps: { innerHTML: _vm._s(_vm.dialogBoxMessage) }
                  },
                  [
                    _vm._v(
                      _vm._s(this.dialogBoxMessage) +
                        ". Please check your junk mail to ensure you receive\n                      it."
                    )
                  ]
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "20px" }, attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                {
                  attrs: {
                    span: 12,
                    offset: _vm.userTypeErrorCode === 70000 ? 0 : 12
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "dialog-footer-btn",
                      attrs: { type: "primary" },
                      on: { click: _vm.handleCloseRegisterDialog }
                    },
                    [_vm._v("Close")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.userTypeErrorCode === 70000
                ? [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "dialog-footer-btn",
                            attrs: { type: "primary" },
                            on: { click: _vm.goToUConnect }
                          },
                          [_vm._v("Sign in to U-Connect")]
                        )
                      ],
                      1
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-111d289f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-111d289f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/register/uConnectRegistration/uConnectRegistrationSection1.vue
// module id = null
// module chunks = 